import isEmpty from 'lodash/isEmpty';
import React from 'react';
import { StyledDesktopTitle, StyledMobileTitle, } from './SubscribedPanel.styled';
var SubscribedPanelTitle = function (_a) {
    var mobile = _a.mobile, desktop = _a.desktop;
    return (React.createElement(React.Fragment, null,
        !isEmpty(mobile) && (React.createElement(StyledMobileTitle, { bold: true, "data-testid": "subscribed-panel-mobile-title" }, mobile)),
        !isEmpty(desktop) && (React.createElement(StyledDesktopTitle, { bold: true, "data-testid": "subscribed-panel-desktop-title" }, desktop))));
};
export default SubscribedPanelTitle;
